module.exports = __webpack_public_path__ + "static/media/empty_state.94fccbf4.png";